//ManageSubscription Main File For Both User
import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/SubscriptionFee/ManageSubscription.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { connect } from 'react-redux';
import { AES, enc } from 'crypto-js';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { SUBSCRIPTION_HISTORY_ENDPOINT } from '../../../Services/config/apiEndPoints';

class ManageSubscription extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subscriptionData: [],
            subscriptionHistoryData: [],
            activeSubscriptionData: [],
            activeStatus: 'Inactive',
            subscriptionHistory: 'No history available',
        }
    }
    getHistory = () => {
        ApiCall(
            'GET',
            baseURL + SUBSCRIPTION_HISTORY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({ subscriptionData: data }, () => {
                        let subscriptionHistoryData = [];
                        let activeSubscriptionData = [];
                        this.state.subscriptionData.forEach(sd => {
                            if (sd.subscriptionPlan.activeFlag != true) {
                                subscriptionHistoryData.push(sd);
                            }
                            else {
                                activeSubscriptionData.push(sd);
                            }
                        });
                        this.setState({ activeSubscriptionData, subscriptionHistoryData });
                    })
                }
            }
        });
    }
    componentDidMount = () => {
        this.getHistory();
    }
    toggleActiveStatus = () => {
        this.props.history.push('/BrowseAllPlans', {})
    }
    paymentHistory = (event) => {
        this.state.subscriptionHistoryData.find((data) => {
            if (data.orderId === this.state.subscriptionHistoryData[event].orderId) {
                this.props.history.push({
                    pathname: `/paymentDetails/${data.orderId}`,
                    state: data
                });
            }
        })
    }
    activePaymentHistory = () => {
        this.props.history.push({
            pathname: `/paymentDetails/${this.state.activeSubscriptionData[0]?.orderId}`,
            state: this.state.activeSubscriptionData[0]
        });
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.manageSubscriptionPageTitle} description={TitleDescription.manageSubscriptionPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="mcsnofull">
                    <div id="ManageSubscriptionInsideDiv">
                        <div class="msnononavbar">
                            <div className="msnonavbarname">
                                <small id="nonavc">Manage Subscription</small>
                            </div>
                        </div>
                        <hr class="hr1" />
                        <div class="managementmaincard">
                            {this.props.userProfileDataR?.userType == "Preview" &&
                                <div>
                                    <div class="mmscarddiv1">
                                        <small class="mscarddivsm1">Subscription</small>
                                        <small class="mscarddivsm2">Inactive</small>
                                    </div>
                                </div>
                            }
                            <div>
                                {
                                    this.state.activeSubscriptionData?.length > 0 &&
                                    this.props.userProfileDataR?.userType === "Premium"
                                    &&
                                    <div>
                                        <div class="mmscarddiv1">
                                            <small class="mscarddivsm1">Subscription</small>
                                            <small class="mscarddivsm22" >Active</small>
                                        </div>
                                        <div class="mscardactive1" onClick={() => this.activePaymentHistory()}>
                                            <div class="mscardactive2">
                                                <small class="mscardactivesm1"> {this.state.activeSubscriptionData[0]?.subscriptionPlan?.tenure}</small>
                                                <small class="mscardactivesm1">R {this.state.activeSubscriptionData[0]?.subscriptionPlan?.totalAmount}</small>
                                            </div>
                                            <div class="mscardactive3">
                                                <small class="mscardactivesm2">Plan renewal date :</small>
                                                <small class="mscardactivesm3"> {FormatTimeStamp(this.state.activeSubscriptionData[0]?.subscriptionPlan?.toDate).dateLocal}</small>
                                            </div>
                                            <div class="mscardactive3">
                                                <small class="mscardactivesm2">Started on :</small>
                                                <small class="mscardactivesm3"> {FormatTimeStamp(this.state.activeSubscriptionData[0]?.subscriptionPlan?.fromDate).dateLocal}</small>
                                            </div>
                                            <div class="mscardactive3">
                                                <small class="mscardactivesm2">Valid till :</small>
                                                <small class="mscardactivesm3"> {FormatTimeStamp(this.state.activeSubscriptionData[0]?.subscriptionPlan?.toDate).dateLocal}</small>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="mscarddiv2">
                                    <div class="subhisdiv">
                                        <small class="mscarddivsm1">Subscription History</small>
                                    </div>
                                    {this.state.subscriptionHistoryData.length > 0 ?
                                        <div class="mscardactivefull">
                                            {(this.state.subscriptionHistoryData.map((data, index) => {
                                                return (
                                                    <div class="mscardactive11" key={index} onClick={() => this.paymentHistory(index)}>
                                                        <div class="msout90">
                                                            <div class="mscardactive20">
                                                                <small class="mscardactivesm1">{data.subscriptionPlan.tenure}</small>
                                                            </div>
                                                            <div class="mscardactive3">
                                                                <small class="mscardactivesm2">Order date :</small>
                                                                <small class="mscardactivesm3">{FormatTimeStamp(data.orderDate).dateLocal}</small>
                                                            </div>
                                                            <div class="mscardactive3">
                                                                <small class="mscardactivesm2">Valid till :</small>
                                                                <small class="mscardactivesm3">{FormatTimeStamp(data.subscriptionPlan.toDate).dateLocal}</small>
                                                            </div>
                                                        </div>
                                                        <div class="msout10">
                                                            <img src={rightarrow} id="rightarrowimg" height="23" width="23" class="" alt="" loading="lazy" />
                                                        </div>
                                                    </div>);
                                            }))}
                                        </div>
                                        :
                                        <div>
                                            <small class="mscarddivsm3">No history available</small>
                                        </div>
                                    }
                                </div>
                                <div class="mscarddiv333">
                                    <div class="mscarddivbuttout">
                                        <Button class="mscarddivbutt" onClick={this.toggleActiveStatus}>Browse All Plans</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="msanotifooter01">
                    <Footer />
                </div>
                <div class="msanotifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(ManageSubscription);
